import { useEffect, useState } from "react";
import { BookOpen } from "lucide-react";
import { api } from "@/lib/api";
import { BOOK_STATUSES } from "@/lib/books";
import { BookOrderCard } from "@/components/books/BookOrderCard";
import { BookPriceEditor } from "@/components/books/BookPriceEditor";

export const BookOrdersAdmin = ({ token, fmtDate }) => {
  const [orders, setOrders] = useState(null);
  const [failed, setFailed] = useState(false);
  const [filter, setFilter] = useState("All");
  const auth = { headers: { Authorization: `Bearer ${token}` } };

  useEffect(() => {
    api.get("/admin/book-inquiries", { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setOrders(r.data)).catch(() => setFailed(true));
  }, [token]);

  const replace = (o) => setOrders((os) => os.map((x) => (x.id === o.id ? o : x)));
  const shown = (orders || []).filter((o) => filter === "All" || o.status === filter);

  return (
    <section className="mt-20" data-testid="admin-book-orders">
      <div className="flex flex-wrap items-end justify-between gap-6 mb-8">
        <div>
          <p className="overline mb-3" style={{ color: "var(--gold)" }}>Personalized Swim Books</p>
          <h2 className="font-display text-3xl md:text-4xl" style={{ color: "var(--navy)" }}>Book orders</h2>
          <p className="font-body font-light mt-2" style={{ color: "var(--muted)" }} data-testid="admin-book-count">
            {failed ? "Could not load book orders. Please log out and sign in again." : orders ? `${orders.length} total · Zelle payments are verified by you manually` : "Loading…"}
          </p>
        </div>
        <BookPriceEditor auth={auth} />
      </div>
      <div className="flex flex-wrap gap-2 mb-6" data-testid="book-status-filters">
        {["All", ...BOOK_STATUSES].map((s) => {
          const n = s === "All" ? orders?.length || 0 : (orders || []).filter((o) => o.status === s).length;
          return (
            <button key={s} onClick={() => setFilter(s)} className="px-4 py-1.5 rounded-full text-xs font-body border transition-colors"
              style={filter === s ? { backgroundColor: "var(--navy)", color: "#fff", borderColor: "var(--navy)" } : { borderColor: "rgba(11,27,61,0.2)", color: "var(--navy)" }}
              data-testid={`book-filter-${s.toLowerCase().replace(/\s+/g, "-")}`}>{s} ({n})</button>
          );
        })}
      </div>
      {orders && shown.length === 0 ? (
        <div className="text-center py-14 rounded-2xl border bg-white" style={{ borderColor: "rgba(212,175,55,0.3)" }} data-testid="admin-book-empty">
          <BookOpen size={28} className="mx-auto mb-3" style={{ color: "var(--gold)" }} />
          <p className="font-body font-light" style={{ color: "var(--muted)" }}>Book requests from the Swim Books page will appear here.</p>
        </div>
      ) : (
        <div className="space-y-4">
          {shown.map((o) => <BookOrderCard key={o.id} order={o} auth={auth} fmtDate={fmtDate} onChange={replace} />)}
        </div>
      )}
    </section>
  );
};
